import { render, staticRenderFns } from "./DashboardOverview.vue?vue&type=template&id=41efd045&scoped=true"
import script from "./DashboardOverview.vue?vue&type=script&lang=js"
export * from "./DashboardOverview.vue?vue&type=script&lang=js"
import style0 from "./DashboardOverview.vue?vue&type=style&index=0&id=41efd045&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41efd045",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41efd045')) {
      api.createRecord('41efd045', component.options)
    } else {
      api.reload('41efd045', component.options)
    }
    module.hot.accept("./DashboardOverview.vue?vue&type=template&id=41efd045&scoped=true", function () {
      api.rerender('41efd045', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/dashboard/components/DashboardOverview.vue"
export default component.exports